import { useNavigate } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT } from "../data/content";

export const CTABanner = ({ title = "READY TO TAKE YOUR BUSINESS DIGITAL?", sub = "Let's build a digital presence that attracts, engages and converts." }) => {
  const navigate = useNavigate();
  return (
    <section data-testid="cta-banner" className="relative overflow-hidden bg-dg-navy noise">
      <div className="absolute inset-0 bg-grid-dark" />
      <div className="absolute -bottom-40 left-1/2 h-96 w-[50rem] -translate-x-1/2 rounded-full bg-dg-blue/25 blur-[140px]" />
      <div className="relative mx-auto max-w-5xl px-5 sm:px-8 py-24 sm:py-32 text-center">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-dg-cyan">Let's Grow Your Business</p>
          <h2 className="font-display mx-auto mt-5 max-w-3xl text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.08]">
            {title.split("DIGITAL?").length > 1 ? (
              <>READY TO TAKE YOUR BUSINESS <span className="text-grad">DIGITAL?</span></>
            ) : title}
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base sm:text-lg text-slate-400">{sub}</p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <button
              data-testid="cta-start-project-btn"
              onClick={() => navigate("/contact")}
              className="group inline-flex items-center gap-2 rounded-full bg-dg-cyan px-8 py-4 font-bold text-dg-navy transition-all duration-300 hover:bg-white hover:shadow-[0_0_35px_rgba(0,184,212,0.45)]"
            >
              Start Your Project
              <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
            <a
              data-testid="cta-talk-expert-btn"
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-8 py-4 font-bold text-white transition-all duration-300 hover:border-dg-cyan hover:text-dg-cyan"
            >
              <MessageCircle size={17} /> Talk to an Expert
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
